import React, { useEffect, useState } from "react";
import { Col, Row, Radio, Checkbox, Form, Button } from "antd";
import axios from "../../utils/BasicAuthAPI";
import "./exam.css";

const ExamResult = (props) => {
  
  return (
    <React.Fragment>
      <Row className="exam">
        <Col span={24} style={{ padding: "10px 10px" }}>
          <Row
            justify="space-between"
            style={{ marginBottom: "20px", borderBottom: "1px solid #313452" }}
          >
            <Col span={24}>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Associate Name :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.result.eame}
                </span>
              </p>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Skill Category :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.result["cat"]}
                </span>
              </p>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Skill Level :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.result["lvl"]}
                </span>
              </p>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Total Questions : {props.result.totalQuestions}
              </p>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Total Marks : {props.result.totMarks}
              </p>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Total Acheived Score : {props.result.totAchvMarks}
              </p>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Result :{" "}
                <span
                  style={{
                    color: props.result.result === "Pass" ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {props.result.result}
                </span>
              </p>
            </Col>
            {/* <Col span={8}>
              <p style={{ textAlign: "left", fontSize: "22px" }}>
                Associate Name :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.result.aame}
                </span>
              </p>
            </Col>
            <Col span={8}>
              <p style={{ textAlign: "center", fontSize: "22px" }}>
                Skill Category :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.result["cat"]}
                </span>
              </p>
            </Col>
            <Col span={8}>
              <p style={{ textAlign: "right", fontSize: "22px" }}>
                Skill Level :{" "}
                <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                  {props.result["lvl"]}
                </span>
              </p>
            </Col> */}
          </Row>
          <Row
            justify="space-between"
            style={{ marginBottom: "20px", borderBottom: "1px solid #313452" }}
          >
            <Col span={24}>
              {/* <p style={{ textAlign: "center", fontSize: "34px" }}>
                Total Questions : {props.result.totalQuestions}
              </p>
              <p style={{ textAlign: "center", fontSize: "34px" }}>
                Total Marks : {props.result.totMarks}
              </p>
              <p style={{ textAlign: "center", fontSize: "34px" }}>
                Total Acheived Score : {props.result.totAchvMarks}
              </p> */}
              <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <Button
                  onClick={() => props.backToExam()}
                  type="primary"
                  htmlType="button"
                  className="login-form-button gx-mt-1 bigBtn"
                  style={{
                    height: "50px",
                    fontSize: "22px",
                    padding: "5px 20px",
                  }}
                >
                  {"Back To Exam"}
                </Button>
              </div>
            </Col>
          </Row>

          {/* <p style={{ textAlign: "left", fontSize: "22px" }}>Associate Name : {props.result.result.AssociateName}</p>
                    <p style={{ textAlign: "left", fontSize: "22px" }}>Skill Category : {props.result.result["Skill Category"]}</p>
                    <p style={{ textAlign: "left", fontSize: "22px" }}>Skill Level : {props.result.result["Skill Level"]}</p> */}

          {props.result.answers.map((ans, ind) => {
            return (
              <div style={{ padding: "20px 10px", textAlign: "left" }}>
                <p style={{ fontSize: "22px" }}>
                  {" "}
                  <span>{ind + 1}. </span> {ans.qst}
                </p>
                <span style={{ fontSize: "14px", padding: "5px 30px 5px 0px" }}>
                  Correct Option :{" "}
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {ans.ansActTxt}
                  </span>
                </span>
                <span style={{ fontSize: "14px", padding: "5px 30px" }}>
                  Given Option :{" "}
                  <span
                    style={{
                      color: ans.isCorrect ? "green" : "red",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    {ans.ansGivenTxt}
                  </span>
                </span>
                <span style={{ fontSize: "14px", padding: "5px 0px 5px 30px" }}>
                  Marks :{" "}
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {ans.marksRcvd}/{ans.marksOutOf}
                  </span>
                </span>
              </div>
            );
          })}
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <Button
              onClick={props.backToExam}
              type="primary"
              htmlType="button"
              className="login-form-button gx-mt-1 bigBtn"
              style={{ height: "50px", fontSize: "22px", padding: "5px 20px" }}
            >
              {"Exit"}
            </Button>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default ExamResult;
